// extracted by mini-css-extract-plugin
export default {"cls1":"PaymentViewHistory-ErrorIcon_cls1__Oyeey","cls2":"PaymentViewHistory-ErrorIcon_cls2__vuYwH PaymentViewHistory-ErrorIcon_cls1__Oyeey"};